const testIds = {
  link_wrapper_desktop: 'link_wrapper_desktop',
};

export default testIds;
